import script from "./PaymentSummarySidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSummarySidebar.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSummarySidebar.vue?vue&type=style&index=0&id=11aee144&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11aee144"]])

export default __exports__